import {Component, Input, OnInit} from '@angular/core';
import {ChartOptions} from "../../../components/dashboard/apex-hospital-chart/apex-hospital-chart.component";

@Component({
  selector: 'app-apex-bar-graph2',
  templateUrl: './apex-bar-graph2.component.html',
  styleUrls: ['./apex-bar-graph2.component.scss']
})
export class ApexBarGraph2Component implements OnInit {
  public areaChartOptions!: Partial<ChartOptions>;
  @Input() mLabels!: string[]
  @Input() mCount!: any[]
  @Input() title!: string
  constructor() {
  }
  ngOnInit(): void {
    this.areaChart()
  }
  private areaChart() {
    this.areaChartOptions = {
      series: [
        {
          name: this.title,
          data: this.mCount,
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          distributed: true, // Ensure bars are colored individually
        }
      },
      colors: ['#8E44AD', '#1F8A70', '#b58561', '#2C3E50', '#E74C3C', '#9B59B6', '#3498DB', '#F1C40F'],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: this.mLabels
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },

      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
  }
}
